import { fetchData } from "./fetchData";

export const uploadKmlAPI = async (file, epsilon) => {
    const route = `/kml/upload`;

    const formData = new FormData();
    formData.append('file', file);
    if (epsilon !== undefined && epsilon !== null) {
        formData.append('epsilon', epsilon);
    }

    const options = {
        method: 'POST',
        body: formData
        // No Content-Type header — browser auto-sets multipart boundary
    };

    let response = await fetchData(route, options, true);

    return response;
}
